export const linksSearch = [
  {
    id: 1,
    label: "Autores",
    core: "authors",
    facets: [
      { name: "organizations_alias_str", label: "Organización" },
      { name: "status_str", label: "Estado" },
    ],
  },
  {
    id: 2,
    label: "Documentos",
    core: "documents",
    facets: [
      {
        name: "publications_subtype_str",
        label: "Subtipo de publicación",
      },
      { name: "publisher_str", label: "Publisher" },
      { name: "area_str", label: "Área temáticas" },
      {
        name: "area_investigator_str",
        label: "Área de conocimiento",
      },
      {
        name: "ods_str",
        label: "Objetivos de Desarrollo Sostenible",
      },
      { name: "publication_year", label: "Año de Publicación" },
      { name: "origin_str", label: "Origen" },
      { name: "keyword_str", label: "Palabras Claves" },
    ],
  },
  {
    id: 3,
    label: "Organizaciones",
    core: "organizations",
    facets: [
      { name: "type_str", label: "Tipo" },
      { name: "province_str", label: "Provincia" },
      { name: "city_str", label: "Ciudad" },
    ],
  },
  {
    id: 4,
    label: "Eventos",
    core: "events",
    facets: [
      { name: "city_str", label: "Ciudad" },
      { name: "start_date", label: "Fecha de inicio" },
      { name: "end_date", label: "Fecha de fin" },
    ],
  },
  {
    id: 5,
    label: "Proyectos",
    core: "projects",
    facets: [
      { name: "organizations_alias_str", label: "Organización" },
      { name: "founders_alias_str", label: "Fondeador" },
      {
        name: "start_date",
        label: "Fecha de inicio",
      },
      {
        name: "end_date",
        label: "Fecha de fin",
      },
    ],
  },
  {
    id: 6,
    label: "Patentes",
    core: "patents",
    facets: [
      {
        name: "contributor_name_str",
        label: "Inventores",
      },
      {
        name: "approval_date",
        label: "Fecha de aprobación",
      },
      {
        name: "registration_date",
        label: "Fecha de registro",
      },
    ],
  },
  {
    id: 7,
    label: "Servicios",
    core: "services",
    facets: [
      { name: "organizations_alias_str", label: "Organización" },
      { name: "keywords_str", label: "Palabra clave" },
      { name: "service_types_str", label: "Tipo de servicio" },
    ],
  },
];

export const getFacetsById = (linksSearch, id) => {
  const link = linksSearch.find((item) => item.id === id);
  return link ? link.facets : [];
};

export const getFacetLabelByFacetName = (linksSearch, filter) => {
  const facetAsArray = linksSearch.flatMap((item) => {
    return item.facets;
  });
  return facetAsArray.reduce((str, { name, label }) => {
    const regex = new RegExp(`${name}:"([^"]+)"`, "g");
    return str.replace(regex, `${label}: "$1"`);
  }, filter);
};
